import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AuthLayout from '../../../../layouts/auth/AuthLayout';
import Button from '../../../common/button/Button';

import { ReactComponent as EmailIcon } from '../../../../resources/icons/email.svg';
import { ReactComponent as HashtagIcon } from '../../../../resources/icons/hashtag.svg';

import './forgot-password.scss';

type Props = {
  initiatePasswordReset: (email: string, mobileNumber: string, onSuccess: () => void) => void;
};

const ForgotPassword = ({ initiatePasswordReset }: Props) => {
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');

  const navigate = useNavigate();

  const handleResetPasswordClick = () => {
    if (email || mobileNumber) {
      initiatePasswordReset(email, mobileNumber, () => setEmailSent(true));
    }
  };

  return (
    <AuthLayout>
      <div className="forgot-password">
        {emailSent ? (
          <>
            <div className="forgot-password__success-message-container">
              <p className="forgot-password__message">Thank you.</p>
              <p className="forgot-password__message">
                Please check your email address and/or mobile number for further instructions.
              </p>
            </div>
            <div className="forgot-password__button-container">
              <Button text="Return Home" onClick={() => navigate('/')} auth />
            </div>
          </>
        ) : (
          <>
            <p className="forgot-password__message">
              Please enter the email address and/or mobile number associated with your account:
            </p>
            <div className="forgot-password__input-container">
              <div className="forgot-password__input">
                <EmailIcon className="forgot-password__icon" />
                <input
                  type="text"
                  value={email}
                  onChange={({ target }) => setEmail(target.value)}
                  placeholder="email"
                />
              </div>
              <div className="forgot-password__input">
                <HashtagIcon className="forgot-password__icon" />
                <input
                  type="text"
                  value={mobileNumber}
                  onChange={({ target }) => setMobileNumber(target.value)}
                  placeholder="mobile number"
                />
              </div>
            </div>
            <div className="forgot-password__button-container">
              <Button
                text="Reset Password"
                disabled={!email && !mobileNumber}
                onClick={handleResetPasswordClick}
                auth
              />
            </div>
          </>
        )}
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
